import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { AddSupplierUserComponent } from 'src/app/components/users/add-supplier-user/add-supplier-user.component';
import { RequestAccessTypesEnum } from 'src/app/shared/enum/request-access-types.enum';
@Component({
  selector: 'add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent implements OnInit {
  public loading: boolean = false;
  public raTypes = RequestAccessTypesEnum;

  constructor(
    private route: ActivatedRoute,
    public currentUserService: CurrentUserService,
    private modal: ModalService
  ) { }

  ngOnInit() {
  }

  public openModal(type) {
    if (type === 'supplier') {
      this.modal.close();
      this.modal.open(AddSupplierUserComponent);
    }
  }

  public close() {
    this.modal.close();
  }


}
